import * as XLSX from "xlsx";

/**
 * Export a single-sheet .xlsx file.
 * @param {Object[]} rows - Array of plain objects; keys become column headers.
 * @param {string} filename - File name without extension.
 * @param {string} [sheetName="Dados"] - Sheet tab name.
 */
export const exportToExcel = (rows, filename, sheetName = "Dados") => {
  const ws = XLSX.utils.json_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(wb, `${filename}.xlsx`);
};

/**
 * Export a multi-sheet .xlsx file.
 * @param {{ name: string, rows: Object[] }[]} sheets
 * @param {string} filename - File name without extension.
 */
export const exportToExcelMultiSheet = (sheets, filename) => {
  const wb = XLSX.utils.book_new();
  sheets.forEach(({ name, rows }) => {
    const ws = XLSX.utils.json_to_sheet(rows.length ? rows : [{}]);
    XLSX.utils.book_append_sheet(wb, ws, name.substring(0, 31)); // Excel sheet name limit
  });
  XLSX.writeFile(wb, `${filename}.xlsx`);
};
